import type { Shared } from '@studio/types';
import { isProcessing } from '../isProcessing';

const isAnyMediaProcessing = (items: Shared.Library.BaseMediaItem[]): boolean => {
  return items.some((media) => isProcessing(media));
};

export default isAnyMediaProcessing;
